import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionResponse } from 'src/app/models/assets/QuestionResponse';
import { QuestionRule } from 'src/app/models/question-rules/QuestionRule';
import { Scene } from 'src/app/models/Scene';
import { AssetEvent } from 'src/app/models/vr-events/AssetEvent';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { DeepCopyService } from 'src/app/services/deep-copy.service';
import { FontService } from 'src/app/services/font.service';
import { QuestionRuleService } from 'src/app/services/question-rule.service';
import { ValidationService } from 'src/app/services/validation.service';
import { VrEventTriggerService } from 'src/app/services/vr-event-trigger.service';
import { VrEventTypeService } from 'src/app/services/vr-event-type.service';
import { VrEventService } from 'src/app/services/vr-event.service';

@Component({
  selector: 'app-step-question-details',
  templateUrl: './step-question-details.component.html',
  styleUrls: ['./step-question-details.component.scss'],
})
export class StepQuestionDetailsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;
  @Input('questionProperties') questionProperties: any;

  public fontFamilyOptions: any[];
  public fontSizeOptions: number[];
  public ionSelectFontOptions = {
    cssClass: 'select-font quizard-select'
  };
  public selectOptions = {
    cssClass: 'quizard-select'
  };

  constructor(
    public validationService: ValidationService,
    public vrEventService: VrEventService,
    public vrEventTypeService: VrEventTypeService,
    public vrEventTriggerService: VrEventTriggerService,
    public questionRuleService: QuestionRuleService,
    public assetTypeService: AssetTypeService,
    public deepCopyService: DeepCopyService,
    public fontService: FontService
  ) {
    this.fontFamilyOptions = this.fontService.fontFamilyOptions;
    this.fontSizeOptions = this.fontService.fontSizeOptions;
  }

  ngOnInit() { }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e) {
    this.setModalTransparency(1, e);
  }

  setModalTransparency(opacity, event) {
    if(!this.editing) return;
    var sceneSettingsModal = document.getElementById('add-question-object-modal');
    sceneSettingsModal.style.opacity = opacity;
  }

  getQuestionAsset(): QuestionAsset {
    return this.assetInScene.baseAsset as QuestionAsset;
  }

  getAssetName(sceneAssetRelationId: number): string {
    let asset = this.existingAssetsInScene.find(a => a.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId);
    if(this.assetInScene.sceneAssetRelation.sceneAssetRelationId == sceneAssetRelationId || sceneAssetRelationId == 0)
      return "(Itself)";
    else if (asset)
      return asset.baseAsset.name;
    else
      return "";
  }

  getSceneName(sceneId: number): string {
    return this.existingScenes.find(s => s.sceneId == sceneId).name;
  }

  getResponseName(responseIndex: number): string {
    let question: QuestionAsset = this.assetInScene.assets[this.currentStepInfo.currentQuestionIndex].baseAsset as QuestionAsset;
    return question.responses[responseIndex].text;
  }

  // =============== DETAILS ===============

  textToSpeechChange(event, assetInScene: AssetInScene) {
    if (event.target.checked) {
      assetInScene.sceneAssetRelation.textToSpeechUrl = "Question";
    } else {
      assetInScene.sceneAssetRelation.textToSpeechUrl = null;
    }
  }

  backgroundVisibleChange(event, assetInScene: AssetInScene) {
    let questionAsset = assetInScene.baseAsset as QuestionAsset;
    if (event.target.checked) {
      questionAsset.backgroundOpacity = 1;
    } else {
      questionAsset.backgroundOpacity = 0;
    }
  }

  validateAssetName() {
    this.assetInScene.baseAsset.name = this.validationService.removeHtmlTags(this.assetInScene.baseAsset.name);
  }

  validateMinScoreToPassValue(event, assetInScene: AssetInScene) {
    var questionAsset: QuestionAsset = assetInScene.baseAsset as QuestionAsset;
    var value = +event.target.value;
    value = this.validationService.validateMinValue(value, 0.5);
    value = this.validationService.validateMaxValue(value, 5);
    if (value != Math.floor(value)) {
      value = Math.floor(value) + 0.5;
    }
    questionAsset.score = value;
  }

  validatePlaneColour(event, assetInScene: AssetInScene) {
    var questionAsset: QuestionAsset = assetInScene.baseAsset as QuestionAsset;
    if (questionAsset.planeColour.trim().length == 0) {
      questionAsset.planeColour = "#FFFFFF";
    }
  }

  updateXScale(event, asset) {
    asset.sceneAssetRelation.xScale = String(event.detail.value);
    asset.sceneAssetRelation.yScale = String(event.detail.value);

    asset.sceneAssetRelation.scale = `${asset.sceneAssetRelation.xScale} ${asset.sceneAssetRelation.yScale} ${asset.sceneAssetRelation.zScale}`;
  }

  setQuestionTextSize(ev) {
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    this.getQuestionAsset().textSize = parseFloat(value.toFixed(1));
  }

  validateQuestionTextColour() {
    if (this.getQuestionAsset().textColour.trim().length == 0) {
      this.getQuestionAsset().textColour = "#000000";
    }
  }

  setQuestionResponsesTextSize(ev) {
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }

    value = 55 - value;
    this.questionProperties.questionResponsesTextSize = parseFloat(value.toFixed(1));
  }

  validateQuestionResponsesTextColour() {
    if (this.questionProperties.questionResponsesTextColour.trim().length == 0) {
      this.questionProperties.questionResponsesTextColour = "#000000";
    }
  }

}
